import { createContext, useState, useContext, useEffect } from "react";
import { ShowToast, Severty } from "../helper/toast";
import apiPath from "../constants/apiPath";
import { useSearch } from "./SearchContext";
import useRequest from "../hooks/useRequest";

// Create the context
const PlanContext = createContext();

// Create the provider component
export const PlanProvider = ({ children }) => {
  const [activePlanType, setActivePlanType] = useState("");
  const { searchTerm } = useSearch(); // Using search context
  const [totalDreams, setTotalDreams] = useState(0);
  const [plantype, setPlanType] = useState("");
  const [dreams, setDreams] = useState([]);
  const [dreamCount, setDreamCount] = useState(0);
  const [isSubscriptionActive, setIsSubscriptionActive] = useState(true);
  let [selectedDream, setSelectedDream] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [selectedEmotion, setSelectedEmotion] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const { request } = useRequest();
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  // Function to fetch dreams
  const fetchDreams = async () => {
    try {
      setLoading(true);

      const startDate = dateRange?.startDate
        ? encodeURIComponent(dateRange.startDate)
        : "";
      const endDate = dateRange?.endDate
        ? encodeURIComponent(dateRange.endDate)
        : "";

      request({
        url: `${apiPath.dreams}/list?search=${searchTerm}&emotion=${
          selectedEmotion || ""
        }&startDate=${startDate}&endDate=${endDate}&page=${currentPage}&limit=${limit}`,
        method: "GET",
        onSuccess: (data) => {
          if (data && typeof data === "object" && "status" in data) {
            setLoading(false);

            if (data.status) {
              const dreamList = data.data.dreams;

              setTotalDreams(data.data.totalDreams);
              setPlanType(data.data.subscriptionPlan);
              setActivePlanType(data.data.subscriptionPlan);
              setDreams(dreamList);
              setDreamCount(data.data?.dreamCount);
              setIsSubscriptionActive(data.data.isSubscriptionActive);
              if (dreamList.length > 0) {
                const latestDream = dreamList[0];
              } else {
                setSelectedDream(null);
              }
            }
          }
          setLoading(false);
          setIsFetching(false);
        },
        onError: (error) => {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "An error occurred";
          setLoading(false);
          ShowToast(errorMessage, Severty.ERROR);
        },
      });
    } catch (err) {
      setLoading(false);
      console.log(err, "err");
    }
  };

  useEffect(() => {
    // fetchDreams();
  }, []);

  return (
    <PlanContext.Provider
      value={{
        activePlanType,
        setActivePlanType,
        plantype,
        setPlanType,
        totalDreams,
        setTotalDreams,
        dreams,
        setDreams,
        dreamCount,
        setDreamCount,
        isSubscriptionActive,
        setIsSubscriptionActive,
        selectedDream,
        setSelectedDream,
        loading,
        setLoading,
        isFetching,
        setIsFetching,
        selectedEmotion,
        setSelectedEmotion,
        currentPage,
        setCurrentPage,
        limit,
        setLimit,
        dateRange,
        setDateRange,
        fetchDreams,
      }}
    >
      {children}
    </PlanContext.Provider>
  );
};

// Custom hook to access Plan context
export const usePlan = () => useContext(PlanContext);
